<template>
<!-- 数字产业·土地资源 -->
  <div class="load_source">
    <div
      v-for="(item, index) in loads"
      :key="index"
      :class="item.Class"
      :ref="item.Refs"
      @click="click_load(item.Class, index, item.cont)"
      :v-model="item.boolen_val"
    >
      {{ item.cont }}
    </div>
  </div>
</template>

<script>
import { LatheGeometry } from "three";
name: "load_source";
export default {
  data() {
    return {
      loads: [
        { Class: "cont_gd", Refs: "cont_gd", cont: "耕地", boolen_val: false },
        { Class: "cont_ld", cont: "林地", boolen_val: false },
        { Class: "cont_qt", cont: "其他", boolen_val: false },
        { Class: "cont_sy", cont: "水利设施", boolen_val: false },
      ],
    };
  },
  methods: {
    load() {
      var height = document.body.clientHeight / 2;
      var wid = undefined;
      wid = this.$refs.cont_gd.clientWidth * 2 + 15;
      $(".load_source").css("top", height + "px", "width", wid + "px");
    },
    click_load: function (Class, e, name) {
      this.loads[e].boolen_val = !this.loads[e].boolen_val
      let vnt = this.loads[e].boolen_val
      let vn = !this.loads[e].boolen_val
      if (vnt) {
        plMap.visibleDigitalIndustrial_LegendLayer(
          plMap.digitalIndustrial.curLayerId,
          e
        );
        $(".load_source").children().css("border", "1px solid #fff");
        $("." + Class).css(
          "border", "3px solid #f00",
        );
        this.$set(this.loads, "boolen_val", false)
      }
      if (vn) {
        $(".load_source").children().css("border", "1px solid #fff");
        this.$set(this.loads, "boolen_val", true);
        plMap.removeDigitalIndustrial_LegendLayer()

      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped lang="less">
.load_source {
  position: absolute;
  right: 1%;
  transform: translate(0, -50%);
}
.cont_gd,
.cont_ld,
.cont_qt,
.cont_sy {
  cursor: pointer;
  width: 66px;
  height: 30px;
  border: 1px solid #fff;
  margin: 5px 0;
  text-align: center;
  line-height: 30px;
  overflow: hidden;
  border-radius: 5px;
}
.cont_gd {
  background: url("../../assets/load_source/耕地.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_ld {
  background: url("../../assets/load_source/林地.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_qt {
  background: url("../../assets/load_source/其他.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_sy {
  background: url("../../assets/load_source/水域设施及水利设施用地.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/load_source.vue